
import React, { useEffect, useRef, useState } from 'react';

const Impactzel = () => {


  return (
    <div className='impaczelPage'>
      <div className='container py-5'>
        <div className='col-sm-4 m-auto'>
          <div className='text-center impaczelPage_text1'> THIS NEW SOCIAL PLATFORM CHAMPIONS <br/> YOUR IMPACT, NOT FOLLOWERS.</div>
          <div className='text-center impaczelPage_text2 mt-3'> JOIN THE <br/>WAITING LIST!</div>
        </div>
      </div>
    </div>
  );
};

export default Impactzel;
